import { Theme } from "@material-ui/core/styles";
import coachBackgroundImage from "src/assets/home-page-lander.jpg";
import { hexToRGB } from "src/util";

export const styles = (theme: Theme) => {
  const infoRgb = hexToRGB(theme.palette.info.main);
  const backgroundOpacity = "0.5";
  return {
    activeLink: {
      background: "black",
      borderRadius: 3,
    },
    homeTitle: {
      color: theme.palette.primary.main,
    },
    footerText: {
      color: theme.palette.background.paper,
      display: "block",
      fontSize: "1em",
      textAlign: "center" as "center",
    },
    navLink: {
      padding: 12,
    },
    page: {
      background: `linear-gradient(rgba(${infoRgb}, ${backgroundOpacity}), rgba(${infoRgb}, ${backgroundOpacity})), url(${coachBackgroundImage})`,
      backgroundPosition: "left 50% top 0%",
      backgroundSize: "cover",
      height: "100%",
      overflow: "auto",
      paddingLeft: "10%",
      paddingRight: "10%",
      paddingTop: "5%",
    },
    copyright: {
      marginTop: "0.33rem",
      fontSize: "0.8em",
    },
  };
};



// WEBPACK FOOTER //
// ./src/features/home/pages/styles.ts